import { Button, ButtonGroup, Intent, Position, Size, Tooltip } from "@blueprintjs/core"
import { Fragment, useEffect, useState } from "react"
import { DIALOG_SIZE } from "src/libs/interfaces/layouts"
import { ScalableDialog, showToast } from "src/libs/useful"
import CalloutNoExists from "src/libs/useful/CalloutNoExists"
import { __ } from "src/libs/utilities"
import { HISTORY_TYPE, ICurrentEditType, IHistoryStep, ILandingSection, ILink, SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { LANDING_SCALAR } from "src/modules/pe-landing-module/data/landin_scalars"
import { schema } from "src/modules/pe-landing-module/data/schema"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import LandingCompositeDefault, { isShowByGrands } from "src/modules/pe-landing-module/widgets/composite/LandingCompositeDefault"
import FieldChanger from "../FieldChanger"
import updateSection from "../utils/updateSection"
import CanvasEditForm from "./CanvasEditForm"
import LinkItemEditForm from "./LinkItemEditForm"

/* Protopia Ecosystem component */ 
export interface ILandingEditModalProps { 

}

const LandingEditModal = (props: ILandingEditModalProps): JSX.Element => {
    const currentLanding                    = useLandingStore( (state: ILandingStore) => state.currentLanding )
    const curEditModal: ICurrentEditType    = useLandingStore( (state: ILandingStore) => state.curEditModal )
    const [ value, setValue]                = useState<any>( undefined )
    const [ isDifferent, setIsDifferent]    = useState<boolean>( false )
    
    useEffect(() => { 
        setValue( curEditModal )
        setIsDifferent( false ) 
    }, [ curEditModal ]) 

    const onClose = () => {
        useLandingStore.setState({ curEditModal: undefined })
        setIsDifferent( false )
    }
    const onChange = ( val: any, field: string ) => {
        let newValue: any = {
            ...value,
            [ field ]: val
        }
        setValue( newValue )
        setIsDifferent( true )
    }
    const onUpdate = () => {
        const section: ILandingSection = currentLanding.sections.find((section: ILandingSection) => section.id === curEditModal?.sectionId)
        let newSection: any, isUpdate: boolean = false, tp:string=""
        switch( curEditModal?.currentEditType ) {
            case SELECT_TYPE.CONTENT:
                delete value.sectionId
                delete value.currentEditType
                newSection = {
                    ...section,
                    data: section.data.map(meat => {
                        if(meat.id === value?.id) {
                            return value
                        }
                        return meat
                    })
                }
                isUpdate = true
                tp = "Meat"
                break
            case SELECT_TYPE.FLOAT:
                delete value.sectionId
                delete value.currentEditType
                newSection = {
                    ...section,
                    floats: section.floats.map(meat => {
                        if(meat.id === value?.id) {
                            return value
                        }
                        return meat
                    })
                } 
                isUpdate = true
                tp = "Float"
                break
            case SELECT_TYPE.TITLE: 
                delete value.sectionId
                delete value.currentEditType 
                newSection = {
                    ...section,
                    title: {
                        ...section.title,
                        ...value 
                    }
                }
                isUpdate = true
                tp = "Section title"
                break
            case SELECT_TYPE.DESCRIPTION: 
                delete value.sectionId
                delete value.currentEditType 
                newSection = {
                    ...section,
                    description: value 
                }
                isUpdate = true
                tp = "Section description"
                break
            case SELECT_TYPE.DELIMITER: 
                delete value.sectionId
                delete value.currentEditType 
                newSection = {
                    ...section,
                    delimiter: {
                        ...section.delimiter,
                        ...value 
                    }
                }
                isUpdate = true
                tp = "Section delimiter"
                break
            case SELECT_TYPE.BACKGROUND: 
                delete value.sectionId
                delete value.currentEditType 
                newSection = {
                    ...section,
                    background: {
                        ...section.background,
                        ...value 
                    }
                }
                isUpdate = true
                tp = "Section background"
                break
            case SELECT_TYPE.LINK_ITEM: 
                
                console.log(value)
                
                delete value.sectionId
                delete value.currentEditType 
                newSection = {
                    ...section,
                    data: section.data.map(meat => {
                        if( value.primitive.id === meat.id) {
                            return {
                                ...value.primitive,
                                items: value.primitive.items.map((item: ILink, i: number) => {
                                    if(value.order === i) {
                                        const newItem = { ...value }
                                        delete newItem.order
                                        delete newItem.primitive
                                        return {
                                            ...item,
                                            ...newItem
                                        }
                                    }
                                    return item
                                })
                            }
                        }
                        return meat
                    })
                }
                isUpdate = true
                tp = "Link item" 
                break
            default:
                showToast({
                    message: `Unknown update type: ${ curEditModal?.currentEditType || "none" }`
                })    
        }
        if( isUpdate ) {
            const step: IHistoryStep = {
                prevData: JSON.parse(JSON.stringify( section )),
                data: newSection,
                type: HISTORY_TYPE.SECTION,
                title: `Edit ${tp}`
            }
            updateSection(
                newSection, 
                step,
                [ ].includes( curEditModal?.currentEditType )
            ) 
        }
        onClose()
    } 
    const onHide = () => {
       setValue( { ...value, isHidden: !value.isHidden } )
       setIsDifferent( true )
    }
    if( curEditModal?.currentEditType === SELECT_TYPE.CONTENT && value?.type === LANDING_SCALAR.CANVAS ) {
        return <CanvasEditForm sectionId={ curEditModal?.sectionId } value={value} onClose={onClose} onChange={onChange} onUpdate={onUpdate} />
    }
    return <ScalableDialog
            isOpen={ !!curEditModal?.currentEditType }
            onClose={ onClose }
            dialogSize={ DIALOG_SIZE.NORMAL }
            isCloseButtonShown
            isScale
            mayFullScreen
            footer={
                <ButtonGroup size={Size.LARGE} fill>
                    {
                        <Tooltip
                            intent={ Intent.PRIMARY }
                            position={ Position.TOP_RIGHT }
                            content={ __( value?.isHidden ? "Do show": "Do hide" ) }
                        >
                            <Button className="px-4" icon={ !!value?.isHidden ? "eye-off" : "eye-open" } intent={Intent.DANGER}  onClick={ onHide }/>
                        </Tooltip>
                    }
                    <Button fill intent={Intent.SUCCESS} disabled={!isDifferent} onClick={onUpdate}>
                        { __("Update") }
                    </Button>
                    <Button fill intent={Intent.NONE} onClick={onClose}>
                        { __("Cancel") }
                    </Button>
                </ButtonGroup>
            }
        > 
            { 
                !!value?.currentEditType 
                    ?
                    <div className={`max-height d-flex flex-column flex-grow-100`}>
                        <div className={`overflow-y-auto flex-grow-100 ${value.isHidden ? "opacity_5 untouchble" : ""}`}>
                            <div className="pt-4 px-0 min-height-300">
                                <LandingEditModalContent value={value} onChange={onChange} />
                            </div>
                        </div>
                        
                    </div>
                    :
                    <></>
            }
        </ScalableDialog> 
}
export default LandingEditModal


const LandingEditModalContent = ({value, onChange}: any): JSX.Element => {
    const currentLanding                    = useLandingStore( (state: ILandingStore) => state.currentLanding )
    const curEditModal: ICurrentEditType    = useLandingStore( (state: ILandingStore) => state.curEditModal )
    const sectionEditTab: string            = useLandingStore( (state: ILandingStore) => state.sectionEditTab ) // now: only Section
    
    const section: ILandingSection          = currentLanding.sections.find((section: ILandingSection) => section.id === curEditModal?.sectionId)

    const onBackgroundChange = (value: any, field : string, dop: any) => {
        onChange( value, field, dop )
    }
    const onContentChange = (value: any, field : string, dop: any) => {
        onChange( value, field, dop )
    } 
    
    switch( curEditModal?.currentEditType ) {
        case SELECT_TYPE.SECTION:
            const dataSchema = schema().Section
            
            return <Fragment>
                {/* <h3 className="h px-5">{ sectionEditTab }</h3>
                <div className="mb-3 text-success">
                    designType ::: { section.designType }
                </div> */}
                {
                    Object.keys( dataSchema.apollo_fields )
                        .filter(field => dataSchema && 
                            dataSchema.apollo_fields[ field ].tab === sectionEditTab && 
                            !dataSchema.apollo_fields[ field ].isHidden 
                        )
                        .filter( key => { 
                            /* Скрыть, если хотя бы один из стека require=false */
                            return isShowByGrands(dataSchema.apollo_fields, key, section)
                        })
                        //.filter((af: string) => !dataSchema.apollo_fields[af].parent)
                        .map(( field: string ) => { 
                            // return <div key={ field }>
                            //     { field }
                            // </div>  
                            return <Fragment key={ field }> 
                                <FieldChanger 
                                    {...dataSchema.apollo_fields[ field ]}
                                    // type="Section"
                                    field={ field }
                                    value={ section[ field ] }
                                    origin={ section }
                                    onChange={ ( section: any, _field: string, data: any ) => onChange( section, _field, data, field ) }
                                    notClear
                                />
                            </Fragment>
                        })
                }
            </Fragment>
        case SELECT_TYPE.CONTENT:
            // console.log( value.type ) 
            return value.type === LANDING_SCALAR.CANVAS && false 
                ?
                <> CANVAS </>
                :
                <> 
                    <LandingCompositeDefault
                        isAlwaysOpen
                        isNotCard={false}
                        dataSection="Section"
                        dataName={ value.type }
                        type={ value.type }
                        value={ value } 
                        origin={ value }
                        onChange={onContentChange}
                        sectionId={curEditModal?.sectionId}
                    />
                </> 
        case SELECT_TYPE.TITLE:
            return <LandingCompositeDefault
                isAlwaysOpen
                isNotCard={false}
                dataSection="Section"
                dataName={ "Title" }
                type={ "Title" }
                value={ { ...currentLanding.title, ...section.title } } 
                onChange={onChange}
                sectionId={curEditModal?.sectionId}
            />
        case SELECT_TYPE.DESCRIPTION:
            return <LandingCompositeDefault
                isAlwaysOpen
                isNotCard={false}
                dataSection="Section"
                dataName={ "Description" }
                type={ "Description" }
                value={ value } 
                onChange={onChange}
                sectionId={curEditModal?.sectionId}
            />
        case SELECT_TYPE.BACKGROUND:
            return <LandingCompositeDefault
                isAlwaysOpen
                isNotCard={false}
                dataSection="Section"
                dataName={ "LandingBackground" }
                type={ "LandingBackground" }
                value={ value } 
                onChange={onBackgroundChange}
                sectionId={curEditModal?.sectionId}
            />
        case SELECT_TYPE.DELIMITER:
            return <LandingCompositeDefault
                isAlwaysOpen
                isNotCard={false}
                dataSection="Section"
                dataName={ "Delimiter" }
                type={ "Delimiter" }
                value={ value } 
                onChange={onChange}
                sectionId={curEditModal?.sectionId}
            />
        case SELECT_TYPE.FLOAT:
            return <LandingCompositeDefault
                isAlwaysOpen
                isNotCard={false}
                dataSection="Section"
                dataName={ "Float" }
                type={ "Float" }
                value={ value } 
                onChange={onChange}
                sectionId={curEditModal?.sectionId}
            />
        case SELECT_TYPE.LINK_ITEM:
            return <LinkItemEditForm data={value} onChange={onChange} />
        default:
            return <CalloutNoExists message={`Unknown content type: ${ curEditModal?.currentEditType }`}/>
    }
}